import { render, staticRenderFns } from "./project_list.vue?vue&type=template&id=18aaa300&scoped=true"
import script from "./project_list.vue?vue&type=script&lang=js"
export * from "./project_list.vue?vue&type=script&lang=js"
import style0 from "./project_list.vue?vue&type=style&index=0&id=18aaa300&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aaa300",
  null
  
)

export default component.exports